import { formatCurrency } from "./format";

type PurchaseAvailability = {
  totalAmountInCents: number;
  cardBalanceInCents: number;
  period: string;
  periodLimit: number;
  spent: number;
  allowPurchaseWithNegativeBalance?: boolean;
};

// Card and cart values are cents; period values in the UI store are reais.
export const getPurchaseAvailability = ({
  totalAmountInCents, cardBalanceInCents, period, periodLimit, spent,
  allowPurchaseWithNegativeBalance,
}: PurchaseAvailability) => {
  const remainingLimit = Math.max(0, Math.round((periodLimit - spent) * 100));
  const funds = Math.max(0, cardBalanceInCents);
  const periodCap = period ? remainingLimit : null;
  const availableInCents = allowPurchaseWithNegativeBalance
    ? periodCap
    : Math.min(funds, periodCap ?? funds);
  let message = "";
  if (!allowPurchaseWithNegativeBalance && totalAmountInCents > funds) {
    message = `Saldo insuficiente. Sua compra custa ${formatCurrency(totalAmountInCents / 100)} e seu saldo é ${formatCurrency(cardBalanceInCents / 100)}. Faça uma recarga para continuar. O limite de gastos não adiciona dinheiro à carteira.`;
  } else if (period && totalAmountInCents > remainingLimit) {
    message = `Esta compra ultrapassa seu limite de gastos. Você ainda pode gastar ${formatCurrency(remainingLimit / 100)} neste período. Reduza o valor do carrinho.`;
  }
  return { availableInCents, message, sufficient: message === "" };
};

export const getCheckoutErrorMessage = (message: unknown): string => {
  if (message === "there is no enough balance on the virtual card") {
    return "Saldo insuficiente para concluir a compra. Confira sua carteira e faça uma recarga. O limite de gastos não adiciona dinheiro ao saldo.";
  }
  if (message === "there is no enough stock for one or more products") {
    return "Um ou mais itens do carrinho não possuem estoque. Remova esses itens para continuar.";
  }
  if (message === "one or more products are blocked for this client") {
    return "Um ou mais produtos estão bloqueados para este aluno. Confira as restrições com o responsável.";
  }
  return "Não foi possível confirmar a compra. Confira seus pedidos antes de tentar novamente. Se o problema continuar, peça ajuda à cantina.";
};
